import React, { useState } from 'react';
import { useT } from '../i18n';

interface EmailCaptureProps {
  sessionId: string;
}

export default function EmailCapture({ sessionId }: EmailCaptureProps) {
  const t = useT();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'done' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setStatus('sending');
    try {
      const res = await fetch('/api/votes/email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId, email: email.trim() }),
      });
      if (res.ok) {
        setStatus('done');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  if (status === 'done') {
    return <p className="text-sm text-emerald-600 text-center">{t('email.thanks')}</p>;
  }

  return (
    <form onSubmit={handleSubmit} className="flex gap-2 w-full max-w-sm mx-auto">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t('email.placeholder')}
        required
        className="flex-1 px-4 py-2.5 bg-white border border-stone-300 rounded-lg text-stone-700 text-sm font-sans placeholder-stone-400 focus:outline-none focus:border-stone-500 transition-colors"
      />
      <button
        type="submit"
        disabled={status === 'sending'}
        className="px-5 py-2.5 border border-stone-300 hover:border-stone-500 text-stone-500 hover:text-stone-700 text-sm font-sans rounded-lg transition-all disabled:opacity-50"
      >
        {status === 'sending' ? '...' : t('email.submit')}
      </button>
    </form>
  );
}
